import { render } from "./ArrowSVG.vue?vue&type=template&id=03ac8b54&ts=true"
import script from "./ArrowSVG.vue?vue&type=script&lang=ts"
export * from "./ArrowSVG.vue?vue&type=script&lang=ts"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__